import { Pill } from "@uni-kit/ui";
import type { SafetySignal as WireSafetySignal } from "@tether/contracts/collections";
import { isObj, str } from "./parse";

export type SafetySignal = WireSafetySignal;
const levels = new Set<SafetySignal["level"]>(["low", "medium", "high"]);
const directions = new Set<SafetySignal["direction"]>(["inbound", "outbound"]);

export function parseSafety(v: unknown): SafetySignal | undefined {
  if (!isObj(v)) return undefined;
  const level = str(v.level) as SafetySignal["level"] | null;
  const direction = str(v.direction) as SafetySignal["direction"] | null;
  if (!level || !levels.has(level) || !direction || !directions.has(direction) || !Array.isArray(v.reasons)) return undefined;
  const reasons = v.reasons.map(str).filter((x): x is string => x !== null).slice(0, 8);
  return reasons.length ? { level, direction, reasons } : undefined;
}

export function SafetyBadge({ signal }: { signal: SafetySignal }) {
  const tone = signal.level === "high" ? "danger" : signal.level === "medium" ? "warn" : "info";
  const label = signal.direction === "outbound" ? "Sensitive outbound" : signal.level === "high" ? "High-risk inbound" : "Review inbound";
  return <Pill tone={tone}>{label}</Pill>;
}
